import {
  Link,
  Paper,
  Table,
  TableBody,
  TableContainer,
  TableRow,
  Typography,
} from '@mui/material';
import React from 'react';
import { TenantHealthStatusCollection } from '../Model/HealthModels';
import { useDashboardCommonStyles as useStyles } from '../../../../Common/Styles';
import { StatusIcon, TableCell } from '../Common/CommonMethods';

const TenantInsights = ({ Components }: TenantHealthStatusCollection) => {
  const { classes } = useStyles();
  return (
    <Paper sx={{ marginLeft: 2 }} elevation={0}>
      <TableContainer component={Paper} className={classes.tableContainer}>
        <Table>
          <TableBody>
            {Components.map((component) => (
              <TableRow key={component.Url} className={classes.TableRow}>
                <TableCell>
                  <Typography>{component.Url}</Typography>
                </TableCell>
                <TableCell colSpan={4}>
                  <Link href={component.Url} target="_blank">
                    {StatusIcon(
                      component.Status,
                      component.ResponseTime + ' s',
                    )}
                  </Link>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Paper>
  );
};
export default TenantInsights;
